import type { MarketingNavLink } from './content';
import type { MarketingLandingCopy } from '@/i18n/marketing-landing-copy';

const SOLUTIONS_HREF = '#solutions';
const RESOURCES_HREF = '#resources';

export type MobileNavSection = {
  title: string;
  links: Array<MarketingNavLink>;
};

/**
 * Mobile keeps each top-level dialog section expanded. The role and industry
 * titles stay desktop-only, so their links merge under the Solutions bar.
 */
export function getMobileNavSections(
  copy: MarketingLandingCopy
): Array<MobileNavSection> {
  const solutionsLabel =
    copy.primaryNav.find((link) => link.href === SOLUTIONS_HREF)?.label ??
    copy.solutionsGroups[0]?.title ??
    '';

  const resourcesLabel =
    copy.primaryNav.find((link) => link.href === RESOURCES_HREF)?.label ??
    copy.resourcesGroup.title;

  return [
    {
      title: solutionsLabel,
      links: copy.solutionsGroups.flatMap((group) => group.links),
    },
    {
      title: resourcesLabel,
      links: copy.resourcesGroup.links,
    },
  ];
}

/** Pricing stays a direct route; Solutions and Resources are dialog sections. */
export function getMobileFlatLinks(
  copy: MarketingLandingCopy
): Array<MarketingNavLink> {
  return copy.primaryNav.filter((link) => !link.href.startsWith('#'));
}
